"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "initWordPress", {
  enumerable: true,
  get: function get() {
    return _initWordPress.default;
  }
});
Object.defineProperty(exports, "buildWordpressUrl", {
  enumerable: true,
  get: function get() {
    return _buildWordpressUrl.default;
  }
});
exports.isWordPress = exports.isWordPressAdmin = void 0;

var _initWordPress = _interopRequireDefault(require("./initWordPress"));

var _checkIfWordPress = _interopRequireDefault(require("./checkIfWordPress"));

var _getLeadinConfig = _interopRequireDefault(require("./getLeadinConfig"));

var _buildWordpressUrl = _interopRequireDefault(require("./buildWordpressUrl"));

var isWordPress = (0, _checkIfWordPress.default)();
exports.isWordPress = isWordPress;
var isWordPressAdmin = (0, _getLeadinConfig.default)().admin;
exports.isWordPressAdmin = isWordPressAdmin;